import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Epoxygulve from "./pages/Epoxygulve";
import Industrigulve from "./pages/Industrigulve";
import FugefrieGulve from "./pages/FugefrieGulve";
import Flydemoertel from "./pages/Flydemoertel";
import Kvartsgulve from "./pages/Kvartsgulve";
import Gulvloesninger from "./pages/Gulvloesninger";
import Referencer from "./pages/Referencer";
import OmOs from "./pages/OmOs";
import Kontakt from "./pages/Kontakt";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-concrete-50 text-concrete-900 antialiased">
        {/* Scroll Restoration */}
        <ScrollToTop />

        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/epoxygulve" element={<Epoxygulve />} />
            <Route path="/industrigulve" element={<Industrigulve />} />
            <Route path="/fugefrie-gulve" element={<FugefrieGulve />} />
            <Route path="/flydemoertel" element={<Flydemoertel />} />
            <Route path="/kvartsgulve" element={<Kvartsgulve />} />
            <Route path="/gulvloesninger" element={<Gulvloesninger />} />
            <Route path="/referencer" element={<Referencer />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}
